// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__T9PuZ","hidden":"PageLoader_hidden__8pRBf","content":"PageLoader_content__O7Jdz"};